const columnDefs = [
  {
    field: 'marginProfile',
    headerName: 'Profile Name',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'product',
    headerName: 'Product',
    filter: 'agMultiColumnFilter',
    initialWidth: 150,
  },
  {
    field: 'initialMarginRateMultiplier',
    headerName: 'Initial Multiplier',
    filter: 'agMultiColumnFilter',
    initialWidth: 180,
  },
  {
    field: 'maintenanceMarginRateMultiplier',
    headerName: 'Maintenance Multiplier',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
  },
  {
    field: 'maxInitialMarginRate',
    headerName: 'Max Initial Rate',
    filter: 'agMultiColumnFilter',
    initialWidth: 160,
  },
  {
    headerName: 'Min Initial Rate',
    field: 'minInitialMarginRate',
    filter: 'agMultiColumnFilter',
    initialWidth: 160,
  },
  {
    headerName: 'Max Maintenance Rate',
    field: 'maxMaintenanceMarginRate',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
  },
  {
    headerName: 'Min Maintenance Rate',
    field: 'minMaintenanceMarginRate',
    filter: 'agMultiColumnFilter',
    initialWidth: 200,
  },
  {
    headerName: 'Spreads Max Initial Rate',
    field: 'spreadsMaxInitialMarginRate',
    filter: 'agMultiColumnFilter',
    initialWidth: 220,
  },
  {
    headerName: 'Spreads Max Maintenance Rate',
    field: 'spreadsMaxMaintenanceMarginRate',
    filter: 'agMultiColumnFilter',
    initialWidth: 250,
  },
  {
    headerName: 'Spreads Min Initial Rate',
    field: 'spreadsMinInitialMarginRate',
    filter: 'agMultiColumnFilter',
    initialWidth: 220,
  },
  {
    headerName: 'Spreads Min Maintenance Rate',
    field: 'spreadsMinMaintenanceMarginRate',
    filter: 'agMultiColumnFilter',
    initialWidth: 250,
  },
  {
    headerName: 'Public Name',
    field: 'publicName',
    filter: 'agMultiColumnFilter',
    initialWidth: 180,
  },
  {
    headerName: 'Publish to Website',
    field: 'publishToWebsite',
    filter: 'agMultiColumnFilter',
    initialWidth: 180,
  },
];

export default columnDefs;
